/*
  Gaveindpakning pr. vare i kurven
  Gemmer valget som line item property via /cart/change.js
  Bruges sammen med snippets/cart-gift-wrap.liquid
*/
if (!customElements.get('cart-gift-wrap')) {
  class CartGiftWrap extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.cart-gift-wrap__input');
      this.error = this.querySelector('.cart-gift-wrap__error');

      if (!this.input || this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      // Stop hændelserne her, så temaets kurv-script ikke tror, det er en ændring af antal
      ['change', 'input'].forEach((type) => {
        this.input.addEventListener(type, (event) => event.stopPropagation());
      });
      this.addEventListener('click', (event) => event.stopPropagation());

      this.input.addEventListener('change', () => this.update());
    }

    getProperties() {
      try {
        const parsed = JSON.parse(this.dataset.properties || '{}');
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch (e) {
        return {};
      }
    }

    async getCurrentProperties(key) {
      try {
        const response = await fetch(this.getRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
        if (response.ok) {
          const cart = await response.json();
          const item = (cart.items || []).find((i) => i.key === key);
          if (item && item.properties && typeof item.properties === 'object') {
            return Object.assign({}, item.properties);
          }
        }
      } catch (e) { /* fald tilbage til data-attributten */ }
      return this.getProperties();
    }

    getQuantity() {
      const item = this.closest('[data-item]');
      const field = item ? item.querySelector('.cart__quantity-field') : null;
      const qty = field ? parseInt(field.value, 10) : NaN;
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    getRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async postChange(payload) {
      const response = await fetch(this.getRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });

      const text = await response.text();
      let data = null;
      try { data = JSON.parse(text); } catch (e) { /* ikke JSON */ }

      return { ok: response.ok, status: response.status, data, text };
    }

    async update() {
      const checked = this.input.checked;
      const name = this.dataset.propertyName;
      const value = this.dataset.propertyValue;
      const oldKey = this.dataset.key;
      const lineIndex = Number(this.dataset.line);
      const itemEl = this.closest('[data-item]');

      this.classList.add('is-loading');
      if (this.error) this.error.hidden = true;

      try {
        // Hent varens nuværende properties (fx Farve) direkte fra Shopify,
        // så intet går tabt – sæt/fjern derefter kun gaveindpakning
        const properties = await this.getCurrentProperties(oldKey);
        delete properties[name];
        if (checked) properties[name] = value;

        const quantity = this.getQuantity();

        // 1. forsøg: med line item key
        let result = await this.postChange({ id: oldKey, quantity, properties });

        // 2. forsøg: med linjenummer
        if (!result.ok && lineIndex > 0) {
          console.warn('[Gaveindpakning] Første forsøg fejlede, prøver med linjenummer', result.status, result.text);
          result = await this.postChange({ line: lineIndex, quantity, properties });
        }

        if (!result.ok || !result.data || !Array.isArray(result.data.items)) {
          throw new Error('Status ' + result.status + ': ' + result.text);
        }

        const cart = result.data;
        const variantId = Number(this.dataset.variantId);

        // Hvis Shopify har slået to linjer sammen, passer DOM'en ikke længere – genindlæs
        const holder = itemEl ? itemEl.parentElement : null;
        const domCount = holder ? holder.querySelectorAll(':scope > [data-item]').length : cart.items.length;

        if (cart.items.length !== domCount) {
          window.location.reload();
          return;
        }

        // Find den opdaterede linje (dens key ændrer sig, når properties ændres)
        const candidates = cart.items.filter((item) => {
          const hasGift = (item.properties || {})[name] === value;
          return Number(item.variant_id) === variantId && hasGift === checked;
        });

        const newItem = candidates.length === 1 ? candidates[0] : cart.items[lineIndex - 1];

        if (!newItem) {
          window.location.reload();
          return;
        }

        this.replaceKey(itemEl || this, oldKey, newItem.key);
        this.dataset.properties = JSON.stringify(newItem.properties || {});
      } catch (error) {
        console.error('[Gaveindpakning] Kunne ikke opdatere varen:', error);
        this.input.checked = !checked;
        if (this.error) this.error.hidden = false;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    // Opdater den gamle line item key til den nye overalt i varens HTML,
    // så antal og "Fjern" fortsat virker uden at kurven skal genindlæses
    replaceKey(root, oldKey, newKey) {
      if (!oldKey || !newKey || oldKey === newKey) return;

      [root, ...root.querySelectorAll('*')].forEach((el) => {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.value.includes(oldKey)) {
            el.setAttribute(attr.name, attr.value.split(oldKey).join(newKey));
          }
        });
      });
    }
  }

  customElements.define('cart-gift-wrap', CartGiftWrap);
}